import Vue from 'vue'
import tools from './tools/tools'
import routerPc from './router/pc'
import routerMobile from './router/mobile'
import store from './store'

Vue.config.productionTip = false

// 根据不同平台，使用不同路由
let router = routerPc
let App = () => import('@/PcApp.vue')

// 移动端使用移动端路由
if (tools.isMoble()) {
  router = routerMobile
  App = () => import('@/MobileApp.vue')
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
